import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IGridView, IUserPreferences, TViewsKeys } from '../../../shared/models/user-preferences.model';

export const USER_PREFERENCES_API_ACTIONS = createActionGroup({
  source: 'User API Preferences',
  events: {
    get: emptyProps(),
    getError: emptyProps(),
    getSuccess: props<{ data: IUserPreferences }>(),

    upload: emptyProps(),
    uploadError: emptyProps(),
    uploadSuccess: emptyProps(),
  },
});

export const USER_PREFERENCES_ACTIONS = createActionGroup({
  source: 'User Preferences',
  events: {
    /**
     * This action updates store with partial provided user preferences.
     * Use it to update any piece of preferences you need.
     * example:
     * USER_PREFERENCES_ACTIONS.update({ data: { favouritePagesUrl: updatedFavouritePages } });
     * USER_PREFERENCES_ACTIONS.update({ data: { isNavigationPinned: true } });
     * etc...
     */
    update: props<{ data: Partial<IUserPreferences> }>(),

    pinNavigation: emptyProps(),
    unpinNavigation: emptyProps(),

    toggleFavouritePage: props<{ pageUrl: string }>(),
  },
});

export const REPORT_VIEWS_ACTIONS = createActionGroup({
  source: 'Report views',
  events: {
    create: props<{ viewKey: TViewsKeys; view: IGridView }>(),
    delete: props<{ viewKey: TViewsKeys; label: string }>(),
    rename: props<{ viewKey: TViewsKeys; currentLabel: string; newLabel: string }>(),
    update: props<{ viewKey: TViewsKeys; view: IGridView }>(),
  },
});
